'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

/**
 * Root error boundary. React swallows errors thrown while rendering the root
 * layout, so without this they reach neither Sentry nor a useful screen.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          fontFamily: 'system-ui, sans-serif',
          display: 'flex',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 0,
          background: '#fafafa',
          color: '#171717',
        }}
      >
        <main style={{ maxWidth: 460, padding: 24, textAlign: 'center' }}>
          <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Something went wrong</h1>
          <p style={{ fontSize: 14, color: '#525252', lineHeight: 1.5 }}>
            The page couldn&rsquo;t be loaded. Our team has been notified. Try again, and contact
            your sales rep at Link Imaging if it keeps happening.
          </p>
          {/*
            A plain <a>, not next/link, on purpose: this boundary only renders
            when the root layout itself threw, so the router and the React tree
            below it cannot be trusted. A full document navigation is the one
            reliable way out.
          */}
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a
            href="/"
            style={{
              display: 'inline-block',
              marginTop: 20,
              padding: '8px 16px',
              borderRadius: 6,
              background: '#171717',
              color: '#fff',
              fontSize: 14,
              textDecoration: 'none',
            }}
          >
            Back to the portal
          </a>
        </main>
      </body>
    </html>
  );
}
